import { Platform } from 'react-native';

type FontStyle = {
  fontFamily: string;
  fontWeight?: string;
  ontStyle?: string;
};

const fontWeightMap = {
  Gotham: {
    bold: 'bold',
    normal: 'book',
    '100': 'light',
    '200': 'light',
    '300': 'light',
    '500': 'medium',
    '600': 'medium',
    '700': 'bold',
    '800': 'bold',
    '900': 'bold',
    '400': 'book',
  },
  Lato: {
    bold: 'bold',
    normal: '',
    '100': 'light',
    '200': 'light',
    '300': 'light',
    '500': 'bold',
    '600': 'bold',
    '700': 'bold',
    '800': 'bold',
    '900': 'bold',
    '400': '',
  },
  OpenSans: {
    bold: 'bold',
    normal: 'regular',
    '100': 'light',
    '200': 'light',
    '300': 'regular',
    '400': 'regular',
    '500': 'bold',
    '600': 'bold',
    '700': 'bold',
    '800': 'bold',
    '900': 'bold',
  },
  Roboto: {
    bold: 'bold',
    normal: 'regular',
    '100': 'light',
    '200': 'light',
    '300': 'regular',
    '400': 'regular',
    '500': 'bold',
    '600': 'bold',
    '700': 'bold',
    '800': 'bold',
    '900': 'bold',
  },
  RobotoSlab: {
    bold: 'bold',
    normal: 'regular',
    '100': 'light',
    '200': 'light',
    '300': 'regular',
    '400': 'regular',
    '500': 'bold',
    '600': 'bold',
    '700': 'bold',
    '800': 'bold',
    '900': 'bold',
  },
};

export class FontService {
  static getFontWeight(fontWeight: string, fontFamily: string): string {
    // if the weight modifier doesn't exist for the fontFamily
    if (!fontWeightMap[fontFamily]) {
      return '';
    }
    if (!fontWeight && fontFamily === 'Gotham') {
      return 'book';
    }
    // if no font weight but an existing map for the fontFamily with a 'normal' modifier we return this modifier
    if (!fontWeight && fontWeightMap[fontFamily]?.normal) {
      return fontWeightMap[fontFamily].normal;
    }
    // if no font weight and the above conditions haven't triggered (the font might not need/have a modifier)
    if (!fontWeight) {
      return '';
    }

    return fontWeightMap[fontFamily][fontWeight];
  }

  static getAndroidFont(fontWeight: string, fontFamily: string, italic: boolean): string {
    if (italic) {
      return `${fontFamily}_italic`;
    }
    const modifier: string = FontService.getFontWeight(fontWeight, fontFamily);
    return modifier ? `${fontFamily}_${modifier}` : fontFamily;
  }

  static getStyle = (fontFamily: string, fontWeight: string, italic = false): FontStyle | undefined =>
    Platform.select({
      ios: {
        fontFamily,
        fontWeight,
        fontStyle: italic ? 'italic' : 'normal',
      },
      android: {
        fontFamily: FontService.getAndroidFont(fontWeight, fontFamily, italic),
        fontWeight: undefined,
      },
    });
}

